import ErrorFallback from 'Components/ErrorFallback'
import { DynamicDrawerMenu } from 'Components/Layout/DrawerMenu/DynamicDrawerMenu'
import SchoolDrawerMenuContent from 'Services/ControlDataManagement/Features/School/Components/SchoolDrawerMenuContent'
import {
  SchoolCreatePage,
  SchoolEditPage,
  SchoolListPage
} from 'Services/ControlDataManagement/Features/School/Pages'
import { ErrorBoundary } from 'react-error-boundary'
import { Route, Routes } from 'react-router-dom'

function SchoolRoot() {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <DynamicDrawerMenu drawerMenuContent={<SchoolDrawerMenuContent />} />
      <Routes>
        <Route index element={<SchoolListPage />} />
        <Route path="create" element={<SchoolCreatePage />} />
        <Route path=":id/edit" element={<SchoolEditPage />} />
      </Routes>
    </ErrorBoundary>
  )
}

export default SchoolRoot
